import React from 'react';
// import style from './StateOptions.module.scss';
import states from '../../data/state_hash.json';

interface StateOptionsProps {
  // add State options props here

}

const StateOptions: React.FC<StateOptionsProps> = () => (
  <>
    <option value="">
      State
    </option>
    {/* Add State options Content Here */}
    {states.map(({ name, abbreviation }) => (
      <option value={abbreviation} key={abbreviation}>
        {name}
      </option>
    ))}
  </>
);

export default StateOptions;
